import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import React from 'react';
import { Button, Icon, MiniLoader } from '@pwc/pwc-deals-ui';
import styles from './MenuButtonDelete.module.scss';

const MenuButtonDelete = ({ onClick, isDisabled, loading = false }) => {
  const { t } = useTranslation();
  if (loading) {
    return (
      <div className={styles.wrapper}>
        <div className={styles.loader}>
          <MiniLoader />
        </div>
        <div className={styles.label}>Deleting</div>
      </div>
    );
  }
  return (
    <Button
      className="button-menu"
      onClick={onClick}
      data-testid="menu-button-delete"
      disabled={isDisabled}
    >
      <Icon
        name="bin"
        width="21"
        className={`sr2 outline ${
          isDisabled ? 'icon-grey-medium' : 'icon-orange'
        }`}
      />
      {t('keyFocusAreaMenuDelete')}
    </Button>
  );
};

MenuButtonDelete.defaultProps = {
  isDisabled: false,
};

MenuButtonDelete.propTypes = {
  isDisabled: PropTypes.bool,
};

export default MenuButtonDelete;
